/* eslint-disable @typescript-eslint/no-unused-vars */
// 日志上报

import { SLQ_ENV_MAP } from '@/services/track/configure'
import { APP_ID } from '@/services/track/constants'
import Cookies from 'js-cookie'
import { getTracker } from '.'
import type { AxiosInstance, AxiosResponse } from 'axios'

interface LogData {
  data?: any
  type: string
}
interface RequestLogData extends LogData {
  type: 'request'
  url: string
  trace_id: string
  header?: any
}
interface ResponseLogData extends LogData {
  type: 'response'
  url: string
  trace_id: string
  tti: number
  data: any
}
interface WebsocketLogData extends LogData {
  type: 'websocket'
  data: any
}
interface NavigationLogData extends LogData {
  type: 'navigation'
  /** 旧链接 */
  data: string
}
interface LoadLogData extends LogData {
  type: 'load'
  /**建立链接时间 */
  // connectTime?: number
  /**域名解析时间 */
  // domainLookupTime?: number
  /**响应时间 */
  tti?: number
}

interface ActionLogData extends LogData {
  type: 'action'
  event_type: string
  event_target?: string
  url?: string
  trace_id?: string
}

export const track = async (data: RequestLogData | ResponseLogData | WebsocketLogData | NavigationLogData | LoadLogData | ActionLogData) => {
  /** 默认配置 */
  const DefaultEventOptions = {
    act: 'webappuserlogger',
    env: SLQ_ENV_MAP[process.env.APP_ENV],
    project_id: 'weblogger',
    app_id: APP_ID,
    ua: navigator.userAgent,
  }

  const reportData = {
    ...data,
    ...DefaultEventOptions,
    href: window.location.href,
    uid: Cookies.get('osudb_uid'),
  }

  if (['product', 'preview'].includes(process.env.APP_ENV)) {
    Object.keys(reportData).forEach((key) => {
      if (typeof reportData[key] === 'object' && reportData[key] !== null) reportData[key] = JSON.stringify(reportData[key])
    })
    if (reportData.data?.length > 1000) reportData.data = reportData.data.slice(0, 1000)
    const tracker = await getTracker()
    tracker.report(reportData as any)
  } else {
    // eslint-disable-next-line no-console
    // console.log(reportData)
  }
}

/**
 * 接口性能上报
 * @param interceptor
 */
export const interceptorLoggerHandler = (interceptor: AxiosInstance['interceptors']) => {
  interceptor.response.use((response: AxiosResponse) => {
    const { headers, config = {} } = response || {}
    track({
      type: 'response',
      url: config.url,
      trace_id: headers?.['x-traceid'] || headers?.['x-trace-id'],
      tti: Date.now() - (config as any).traceInfo?.traceStart || 0,
      data: '',
    })
    return response
  })
}
